export default "__VITE_ASSET__Dgl4PG2j__"